export const REQUEST_RESOLVER = 'REQUEST_RESOLVER';
export const RECEIVE_RESOLVER = 'RECEIVE_RESOLVER';

export const REQUEST_SET_RESOLVER = 'REQUEST_SET_RESOLVER';
export const WAITING_SET_RESOLVER = 'WAITING_SET_RESOLVER';
export const RECEIVE_SET_RESOLVER = 'RECEIVE_SET_RESOLVER';
export const ERROR_SET_RESOLVER = 'ERROR_SET_RESOLVER';

export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';

export const REQUEST_CONTENT = 'REQUEST_CONTENT';
export const RECEIVE_CONTENT = 'RECEIVE_CONTENT';
export const ERROR_CONTENT = 'ERROR_CONTENT';
export const REQUEST_SET_CONTENT = 'REQUEST_SET_CONTENT';
export const RECEIVE_SET_CONTENT = 'RECEIVE_SET_CONTENT';
export const ERROR_SET_CONTENT = 'ERROR_SET_CONTENT';
export const CLOSE_SET_CONTENT = 'CLOSE_SET_CONTENT';

export const REQUEST_MIGRATE_ADDRESSES = 'REQUEST_MIGRATE_ADDRESSES';
export const RECEIVE_MIGRATE_ADDRESSES = 'RECEIVE_MIGRATE_ADDRESSES';
export const ERROR_DECODING_ADDRESS = 'ERROR_DECODING_ADDRESS';
export const ERROR_MIGRATE_WITH_ADDRESSES = 'ERROR_MIGRATE_WITH_ADDRESSES';
export const CLEAR_MIGRATE_CONTENT = 'CLEAR_MIGRATE_CONTENT';
export const REQUEST_SUPPORTED_INTERFACES = 'REQUEST_SUPPORTED_INTERFACES';
export const RECEIVE_SUPPORTED_INTERFACES = 'RECEIVE_SUPPORTED_INTERFACES';

// non-redux action types
export const MULTICHAIN_RESOLVER = 'MULTICHAIN_RESOLVER';
export const PUBLIC_RESOLVER = 'PUBLIC_RESOLVER';
export const STRING_RESOLVER = 'STRING_RESOLVER';
export const UNKNOWN_RESOLVER = 'UNKNOWN_RESOLVER';
export const DEFINITIVE_RESOLVER = 'DEFINITIVE_RESOLVER';

export const CONTENT_BYTES = 'CONTENT_BYTES';
export const CONTENT_BYTES_BLANK = '0x0000000000000000000000000000000000000000000000000000000000000000';

export const CONTENT_HASH = 'CONTENT_HASH';
export const MULTICHAIN = 'MULTICHAIN';
export const MULTICOIN = 'MULTICOIN';
export const CONTRACT_ABI = 'CONTRACT_ABI';
export const ADDR = 'ADDR';
